@if ($model() != null) {
    <form class="flow-object-form" (ngSubmit)="onSubmit()" #flowObjectForm="ngForm">
        <!-- Form Builder -->
        <div class="form-builder-wrapper debounce-hidden" #wrapperRef>
            <form-builder [form]="$formSchema()" [options]="options" (change)="formBuilderChange($event)"></form-builder>
        </div>

        <!-- Botões -->
        <div class="form-footer form-group text-right mt-3 mb-1 mr-1">
            <hr />

            <!-- FormSchema -->
            <button type="button" class="btn btn-outline-secondary float-left ml-1"
                    (click)="showFormSchema()"
            >Editar código-fonte</button>

            <!-- Cancelar -->
            <button type="button" class="btn btn-outline-danger mr-2"
                    (click)="closeForm()"
            >Cancelar</button>

            <!-- Salvar -->
            <button type="submit" class="btn btn-outline-primary"
                    [disabled]="!flowObjectForm.form.valid || $isReadOnlyMode()"
            >Salvar Rascunho</button>
        </div>
    </form>

    <!-- Modal do FormSchema -->
    <ng-template #formSchemaRef>
        <i class="button fas fa-times close" matTooltip="Fechar" (click)="formSchemaDialog.close()"></i>

        <button type="button" class="button btn btn-primary" (click)="Utils.copyToClipboard(formSchemaEditorRef, copyInfoRef);">
            <i class="fas fa-copy mr-2"></i>
            <span>Copiar conteúdo</span>
        </button>

        <button type="button" class="button btn btn-outline-info info" #copyInfoRef><span>Conteúdo copiado!</span></button>
        <button type="button" class="button btn btn-outline-info info" #pasteInfoRef><span>Conteúdo colado!</span></button>

        <button type="button" class="button btn btn-success right" (click)="Utils.pasteFromClipboard(formSchemaEditorRef, pasteInfoRef)">
            <i class="fas fa-paste mr-2"></i>
            <span>Colar conteúdo</span>
        </button>

        <textarea class="schema-editor form-control styled-scrollbar" [ngModel]="$formSchemaFlat()" #formSchemaEditorRef></textarea>
    </ng-template>
}
